import { styled } from '@mui/material';
import { shouldNotForwardProps } from '../../../helpers';
import { tableCellClasses } from '../TableCell';
import { TableHead } from '../TableHead';
export const TableHeadStyled = styled(TableHead, shouldNotForwardProps('isCurrentlySticky', 'offsetTop', 'withScrollToStartIcon'))(({ theme, isCurrentlySticky, offsetTop }) => ({
    position: 'sticky',
    top: 0,
    boxShadow: isCurrentlySticky ? theme.shadows[3] : undefined,
    /**
     * Prevents row first cell checkbox to be visible through table header.
     * `-50` doesn't allow header overflow sidebar menu which zIndex is `theme.zIndex.mobileStepper` (1000).
     */
    zIndex: theme.zIndex.mobileStepper - 50,
    [`.${tableCellClasses.head}`]: [
        {
            // backgroundColor: isCurrentlySticky ? theme.palette.background.default : theme.palette.background.light,
            backgroundColor: isCurrentlySticky ? theme.palette.background.default : theme.palette.common.white,
        },
        theme.applyStyles('dark', {
            background: isCurrentlySticky ? theme.palette.zinc[950] : theme.palette.background.light,
        }),
    ],
    ...(offsetTop && {
        top: offsetTop,
    }),
}));
